import { APIResponse, APIResponseDtoImpl } from '../apiresponse';
import { PackStatusDto } from '../../dto/packstatus/packstatusdto';

export interface PackStatusResponse extends APIResponse 
{
    getPackStatusDto(): PackStatusDto;
}

export class PackStatusResponseDtoImpl extends APIResponseDtoImpl implements PackStatusResponse 
{
    private packStatusResponseDto : PackStatusDto;

    getPackStatusDto(): PackStatusDto
    {
        return this.packStatusResponseDto;
    }
    setPackStatusDto(packStatusResponseDto: PackStatusDto)
    {
        this.packStatusResponseDto = packStatusResponseDto;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/packstatus/packstatusresponse.tsx